import '../LandingPage.css';
import aboutImage from '../../assets/about-tech.jpg';
import { FaCheckCircle } from 'react-icons/fa';

const highlights = [
  'Two decades of hands-on engineering experience',
  'Proven delivery across healthcare, finance & e-commerce',
  'Modern, maintainable and scalable architectures',
  'A partnership-first approach to every project',
];

function AboutSection() {
  return (
    <section id="about" className="about-section section">
      <div className="section-content">
        <div className="about-grid">
          <div className="about-image reveal">
            <img
              src={aboutImage}
              alt="Code on a developer's screen"
              className="tech-image"
              width={1200}
              height={600}
              loading="lazy"
              decoding="async"
            />
            <div className="about-image-badge">
              <span className="about-image-badge-value">20+</span>
              <span className="about-image-badge-label">years of craft</span>
            </div>
          </div>

          <div className="about-text reveal reveal-delay-1">
            <h2 className="section-title">
              A software partner you can build the future with
            </h2>
            <p>
              EFSoft is a software engineering company with over 20 years of
              experience building web applications in a wide range of
              technologies. We have delivered projects in many industries,
              including healthcare, finance and e-commerce.
            </p>
            <ul className="about-list">
              {highlights.map((item) => (
                <li key={item}>
                  <FaCheckCircle className="about-list-icon" aria-hidden="true" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}

export default AboutSection;
